// extracted by mini-css-extract-plugin
export default {"NewGroupDialog":"NewGroupDialog_NewGroupDialog__5MBZo"};